import React, {useEffect, useState} from 'react'
import {Box, useRadioGroup, VStack} from '@chakra-ui/react'
import useSortOptions from '_app/hooks/useSortOptions'
import {useRouter} from '_app/hooks/useRouter'
import {CustomRadio} from '_app/components/CustomRadio/CustomRadio'
import URLHelper from '../../helpers/URLHelper/URLHelper'

interface SortMobileProps {
  active: string;
}

const SortMobile = ({ active }: SortMobileProps) => {
  const router = useRouter()

  const [value, setValue] = useState(active)

  const options = useSortOptions().map(option => {
    return { ...option, label: option.label }
  })

  const onSubmit = (value: string) => {
    const params = URLHelper.getSearchParams()

    if (value) {
      params.order = value
    } else {
      delete params.order
    }

    router.search(params)
  }

  const onChange = (value: string) => {
    setValue(value)
    onSubmit(value)
  }

  useEffect(() => {
    setValue(active)
  }, [active])

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'sort',
    defaultValue: value,
    onChange: onChange,
  })

  const group = getRootProps()

  return (
    <>
      <Box flex={1} pb={4}>
        <VStack alignItems="flex-start" spacing={4} {...group}>
          {options.map(o => (
            <CustomRadio
              key={o.value}
              {...getRadioProps({
                value: o.value,
              })}
            >
              {o.label}
            </CustomRadio>
          ))}
        </VStack>
      </Box>
    </>
  )
}

export default SortMobile
